import React from 'react';
import classes from './pending-approval-badge.module.scss';

const DEFAULT_LABEL = 'בקשה ממתינה לאישור מנהל';

type PendingApprovalBadgeProps = {
  className?: string;
  label?: string;
  focusable?: boolean;
  stopPropagation?: boolean;
};

export function PendingApprovalBadge({
  className,
  label = DEFAULT_LABEL,
  focusable = true,
  stopPropagation = false,
}: PendingApprovalBadgeProps) {
  const stopParentAction = (event: React.SyntheticEvent<HTMLSpanElement>) => {
    if (!stopPropagation) return;
    event.stopPropagation();
    if (event.type === 'click') {
      event.preventDefault();
    }
  };

  return (
    <span
      className={`${classes.root} ${className ?? ''}`}
      aria-label={label}
      data-testid="pending-approval-badge"
      tabIndex={focusable ? 0 : undefined}
      onClick={stopParentAction}
      onMouseDown={stopParentAction}
      onTouchStart={stopParentAction}
    >
      <span className={classes.icon} aria-hidden="true">!</span>
      <span className={classes.note} aria-hidden="true">{label}</span>
    </span>
  );
}
